import { useState } from "react";
import { categories } from "@/mocks/categories";

export default function BlogNavbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-background-50/95 backdrop-blur-sm border-b border-background-200/70 sticky top-0 z-50">
      <div className="flex items-center justify-between px-4 md:px-6 lg:px-10 h-16 md:h-20 max-w-6xl mx-auto">
        <a href="/" className="flex items-center gap-2 text-foreground-950 hover:opacity-80 transition-opacity">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-leaf-line text-primary-500 text-xl"></i>
          </div>
          <span className="font-heading font-semibold text-lg tracking-tight whitespace-nowrap">Mulebuy Spreadsheet</span>
        </a>

        <div className="hidden md:flex items-center gap-2">
          <a href="/" className="px-4 py-2 text-sm font-medium text-foreground-800 hover:text-foreground-950 rounded-full transition-colors whitespace-nowrap">
            Home
          </a>

          <a href="/blog/what-is-mulebuy-spreadsheet" className="px-4 py-2 text-sm font-medium text-foreground-800 hover:text-foreground-950 rounded-full transition-colors whitespace-nowrap">
            Shopping Guide
          </a>

          <div className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center gap-2 px-5 py-2.5 border border-foreground-300 rounded-full text-foreground-800 hover:border-foreground-500 hover:text-foreground-950 transition-colors text-sm font-medium whitespace-nowrap"
            >
              <span>Categories</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`ri-arrow-down-s-line transition-transform ${dropdownOpen ? "rotate-180" : ""}`}></i>
              </div>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full mt-2 right-0 bg-background-50 border border-background-200 rounded-2xl shadow-lg py-2 w-56 max-h-[60vh] overflow-y-auto">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setDropdownOpen(false)}
                    className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-primary-50/60 transition-colors"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-full text-foreground-800 hover:bg-background-100 transition-colors"
        >
          <i className={`text-lg ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4 max-h-[70vh] overflow-y-auto">
          <div className="space-y-1 mb-4">
            <a href="/" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-xl text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors">
              <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                <i className="ri-home-line text-primary-500"></i>
              </div>
              Home
            </a>
            <a href="/blog/what-is-mulebuy-spreadsheet" onClick={() => setMobileMenuOpen(false)} className="block px-4 py-3 rounded-xl text-sm font-medium text-foreground-800 hover:bg-background-100 transition-colors">
              <div className="w-4 h-4 inline-flex items-center justify-center mr-2">
                <i className="ri-book-open-line text-primary-500"></i>
              </div>
              Shopping Guide
            </a>
          </div>

          <div className="border-t border-background-200/50 pt-3">
            <p className="px-4 py-2 text-xs font-semibold text-foreground-500 uppercase tracking-wide">Product Categories</p>
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-foreground-700 hover:text-foreground-950 hover:bg-primary-50/60 transition-colors"
              >
                <div className="w-8 h-8 rounded-lg overflow-hidden flex-shrink-0">
                  <img src={cat.image} alt={cat.name} className="w-full h-full object-cover" />
                </div>
                <span>{cat.name}</span>
                <div className="w-4 h-4 flex items-center justify-center ml-auto">
                  <i className="ri-arrow-right-up-line text-foreground-400 text-xs"></i>
                </div>
              </a>
            ))}
          </div>

          <div className="border-t border-background-200/50 pt-3 mt-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-4 py-3 rounded-xl bg-foreground-950 text-white text-sm font-medium hover:bg-foreground-800 transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </div>
              <span>Visit Main Website</span>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}